import { useId } from "react";

/** The ids one chart's gradients and glow are referenced by, unique on the page. */
export interface ChartEffectIds {
  /** The id of the vertical gradient for a series, by its key. */
  gradient: (key: string) => string;
  /** The id of the glow filter. */
  glow: string;
}

/**
 * Ids for one chart's effects. React's ids hold characters an SVG `url(#…)` reference does not take, so they are reduced to
 * letters and digits.
 *
 * @returns The chart's effect ids.
 */
export function useChartEffectIds(): ChartEffectIds {
  const base = `chart-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;
  return { gradient: (key) => `${base}-fill-${key.replace(/[^a-zA-Z0-9]/g, "")}`, glow: `${base}-glow` };
}
